module.exports = __webpack_public_path__ + "img/resetzoom.44a72bf5.svg";